const formatIdForAnchorLink = string => {
  if (typeof string === "string") {
    // remove special characters from headings, as this is the format of links in tableOfContents
    const specialCharacterRegex = /[$&+,:;=?@\/#|'<>.^*()%!]/g;

    const splitString = string
      .toLowerCase()
      .replace(specialCharacterRegex, "")
      .split(" ")
      .join("-");
    return splitString;
  }
};

export { formatIdForAnchorLink };
